import type { SpreadsheetColumnId } from '~/_shared/types/spreadsheetData/spreadsheetColumn';
import { createUuid } from '~/_shared/utils/createUuid';
import {
  type ChartBoundaryStatistics, type ChartId, type ChartMetricDemographic, type ChartMetricSpreadsheetColumn, ChartMetricType, ChartType,
} from './mapSettingsCharts.types';

export const createChartId = (): ChartId => createUuid();

export const createChartBoundaryStatistics = ({
  title, metrics, boundaryGroupId, shouldNormalize, id,
}: { boundaryGroupId: ChartBoundaryStatistics['boundaryGroupId'] } & Partial<ChartBoundaryStatistics>): ChartBoundaryStatistics => ({
  type: ChartType.BoundaryStatistics,
  id: id || createChartId(),
  title,
  metrics: metrics || [],
  boundaryGroupId,
  shouldNormalize,
});

export const createChartMetricSpreadsheetColumn = (
  column: SpreadsheetColumnId
): ChartMetricSpreadsheetColumn => {
  return {
    type: ChartMetricType.SpreadsheetColumn,
    column,
  };
};

export const createChartMetricDemographic = (
  demographicId: string
): ChartMetricDemographic => {
  return {
    type: ChartMetricType.Demographic,
    demographicId,
  };
};
